import PropTypes from "prop-types"

function ToggleClass(element, className) {
  if (element.classList) {
    element.classList.toggle(className);
  } else {
    // For IE9
    let classes = element.className.split(" ");
    let i = classes.indexOf(className);
  
    if (i >= 0) {
      classes.splice(i, 1);
    }
    else {
      classes.push(className);
      element.className = classes.join(" ");
    }
  }
}

function AddClass(element, className) {
  let classes = element.className.split(" ");
  if (classes.indexOf(className) === -1) {
    if (element.className.length === 0) {
      element.className = className;
    } else {
      element.className += " " + className;
    }
  }
}

function RemoveClass(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  }
}

ToggleClass.propTypes = {
  element: PropTypes.node.isRequired,
  className: PropTypes.node.isRequired
}

AddClass.propTypes = {
  element: PropTypes.node.isRequired,
  className: PropTypes.node.isRequired
}

RemoveClass.propTypes = {
  element: PropTypes.node.isRequired,
  className: PropTypes.node.isRequired
}

export { ToggleClass, AddClass, RemoveClass };
